import { of, Observable, OperatorFunction } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { TypedAction } from '@ngrx/store/src/models';

import { reportJsErrorIfAny } from '@bp/shared/rxjs';
import { Action } from '@bp/shared/typings';
import { BpError } from '@bp/shared/models/core';

import { ErrorActionPayload, ResultActionPayload } from '../../ngrx-action-payloads';

export function apiResult<TResult>(
	success: Action<ResultActionPayload<TResult>>,
	failure: Action<ErrorActionPayload>,
): OperatorFunction<TResult | null, TypedAction<string> & (ErrorActionPayload | ResultActionPayload<TResult>)> {
	return (source$: Observable<TResult | null>) => source$.pipe(
		map(result => result
			? success({ result })
			: failure({ error: BpError.notFound })),
		reportJsErrorIfAny,
		catchError((error: unknown) => of(failure({ error: new BpError(error) }))),
	);
}

export function apiVoidResult<TStreamPayload>(
	success: Action,
	failure: Action<ErrorActionPayload>,
): OperatorFunction<TStreamPayload, TypedAction<string> & (ErrorActionPayload | Object)> {
	return (source$: Observable<TStreamPayload>) => source$.pipe(
		map(success),
		reportJsErrorIfAny,
		catchError((error: unknown) => of(failure({ error: new BpError(error) }))),
	);
}

export function apiVoidResultWithRequest<TStreamPayload, TApiRequest>(
	{
		request,
		successAction,
		failureAction,
	}: {
		request: TApiRequest;
		successAction: Action<{ request: TApiRequest }>;
		failureAction: Action<ErrorActionPayload & { request: TApiRequest }>;
	},
): OperatorFunction<TStreamPayload, TypedAction<string> & (ErrorActionPayload | Object)> {
	return (source$: Observable<TStreamPayload>) => source$.pipe(
		map(() => successAction({ request })),
		reportJsErrorIfAny,
		catchError((error: unknown) => of(failureAction({
			error: new BpError(error),
			request,
		}))),
	);
}
